<template>
  <b-container fluid>
    <b-row class="mb-4">
      <b-col sm="8">
        <h3>
          <b-badge variant="primary">
            Additional Details: Individual
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
      <b-col>
        <b-button 
          block
          @click="$router.go(-1)">
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="Object.keys(item).length > 0">
          <b-row v-for="(field, index) in fields" :key="index">
            <b-col :class="{ odd: (index % 2 == 0) }">
              <strong>{{ field.label }}</strong>
            </b-col>
            <b-col :class="{ odd: (index % 2 == 0) }">
              {{ item[field.key] }}
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row class="pt-4">
      <b-col>
        <h3>Individual Questionnaire Outcome</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          small
          responsive
          striped
          stacked="sm"
          :busy="waiting"
          :items="tableItems"
          :fields="tableFields">
          <div slot="table-busy" class="text-center text-danger">
            <b-spinner class="align-middle"></b-spinner>
            <!-- <strong>Loading...</strong> -->
          </div>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { apiService } from '../_services'

export default {
  name: 'IndividualDetails',
  data() {
    return {
      waiting: false,
      PID: '',
      HHID: '',
      item: {},
      fields: [
        {
          key: 'ClaimID',
          label: 'Claim ID'
        },
        {
          key: 'HHID',
          label: 'HHID'
        },
        {
          key: 'PID',
          label: 'View Extra Details For'
        },
        {
          key: 'FirstName',
          label: 'Respondent First Name'
        },
        {
          key: 'LastName',
          label: 'Respondent Last Name'
        },
        {
          key: 'CellNumber',
          label: 'Cell phone Number'
        },
        {
          key: 'TelNumber',
          label: 'Telephone Number'
        },
        {
          key: 'ApproximateAge',
          label: 'Approximate Age of Respondent'
        },
        {
          key: 'Gender',
          label: 'Gender of Respondent'
        },
      ],
      tableItems: [],
      tableFields: [
        {
          key: 'Date',
          label: 'Date'
        },
        {
          key: 'IndividualQuestionnaireOutcome',
          label: 'Outcome'
        },
        {
          key: 'AdditionalDetails',
          label: 'Additional Details'
        },
        {
          key: 'ReasonForRefusal',
          label: 'Reason for Refusal'
        },
      ]
    }
  },
  created() {
    let vm = this
    this.PID = this.$route.params.pid
    this.HHID = this.$route.params.hhid
    this.waiting = true
    apiService.getIndividualDetails(this.HHID, this.PID)
    .then((response) => {
      vm.item = response.data
      vm.tableItems = response.data.Items
      // vm.tableItems = [
      //   {
      //     Date: response.data.Date,
      //     IndividualQuestionnaireOutcome: response.data.IndividualQuestionnaireOutcome,
      //     AdditionalDetails: response.data.AdditionalDetails,
      //     ReasonForRefusal: response.data.ReasonForRefusal,
      //   }
      // ]
      vm.waiting = false
    })
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/IndividualDetailsPage.vue